<template>
  <div id="app">
    <nav-menu v-if="posts" :posts="posts" @toggleNav="toggleNav" :isOpen="navOpen">Menu</nav-menu>
    <transition name="fade">
      <router-view :posts="posts"></router-view>
    </transition>
  </div>
</template>

<script>
import NavMenu from '@/components/NavMenu'

export default {
  name: 'app',
  metaInfo: {
    title: 'The Changing Lawyer',
    titleTemplate: '%s | Microsystems'
  },
  components: {
    NavMenu
  },
  data () {
    return {
      navOpen: false
    }
  },
  computed: {
    posts () {
      if (this.$store.state.posts && this.$store.state.posts.length) {
        return this.$store.state.posts
      }
    }
  },
  methods: {
    toggleNav (state) {
      if (state === 'on') {
        this.navOpen = true
      } else if (state === 'off') {
        this.navOpen = false
      } else {
        this.navOpen = (!this.navOpen)
      }

      if (this.navOpen) {
        document.body.classList.add('js-nav-no-scroll')
      } else {
        document.body.classList.remove('js-nav-no-scroll')
      }
    },
    escapeKeyListener (evt) {
      if (evt.keyCode === 27 && this.navOpen) {
        this.toggleNav()
      }
    }
  },
  watch: {
    '$route': function (value) {
      this.toggleNav('off')
    }
  },
  mounted () {
    document.addEventListener('keyup', this.escapeKeyListener)
  }
}
</script>

<style lang="scss">
// Fonts
@import '~@/assets/scss/_fonts.scss';

// Global styles
html,
body {
  margin: 0;
  padding: 0;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}

body.js-no-scroll {
  @media (min-width: $breakpoint-md) {
    overflow: hidden;
  }
}

body.js-nav-no-scroll  {
  overflow: hidden;
}

#app {
  font-family: $font-body;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1A1919;
  // margin-top: 60px;
  font-size: 16px;

  a:hover {
    text-decoration: none;
  }
}

.loading {
  margin: 0;
  opacity: .3;
  -webkit-animation: spin 4s cubic-bezier(.25,1.15,.64,.3) infinite;
  -moz-animation: spin 4s cubic-bezier(.25,1.15,.64,.3) infinite;
  animation: spin 4s cubic-bezier(.25,1.15,.64,.3) infinite;
}

// Container
.container {
  @media (min-width: $breakpoint-md) {
    width: $breakpoint-md;
    margin: 10px auto;
  }

  @media (min-width: $breakpoint-lg) {
    width: $breakpoint-lg;
    margin: 20px auto;
  }
}

img {
  max-width: 100%;
  height: auto;
}

// TRANSITIONS
.fade-enter-active {
  transition: opacity .5s
}

.fade-enter,
.fade-leave-to {
  opacity: 0
}

@keyframes spin {
  100% {
    transform: rotate(360deg)
  }
}

a {
  text-decoration: none;

  &:hover {
    color: #0F7FC9;
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?785b9e5c